function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex';
export default {
  name: 'pagesHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    backUrl: {
      type: String,
      default: ''
    },
    closeNowTag: {
      type: Boolean,
      default: false
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('menu', ['closeTag'])), {}, {
    goBack: function goBack() {
      var _this = this;
      if (this.backUrl) {
        if (!this.closeNowTag) {
          return this.$router.push({
            path: this.backUrl
          });
        }
        var route = this.$route;
        this.$store.dispatch('tagsView/delView', route).then(function () {
          if (route.path === _this.$route.path) {
            _this.closeTag(route);
            _this.$router.push({
              path: _this.backUrl
            });
          }
        });
      } else {
        this.$router.back();
      }
    },
    closeSelectedTag: function closeSelectedTag() {
      var _this2 = this;
      var route = this.$route;
      this.$store.dispatch('tagsView/delView', route).then(function () {
        if (_this2.isActive(route)) {
          _this2.closeTag(route);
          _this2.$router.push({
            path: _this2.backUrl
          });
        }
      });
    }
  })
};